import store from '@/store'

export function permiteAction (acao) {
  let i = store.state.acesso.permissoes.indexOf(acao)
  if (i === -1) return false
  return true
}



// WEBPACK FOOTER //
// ./src/service/acao.js